export const CookieHashName = "store10";
export const getCookieOptions = (domain:string | undefined)=>{
    //console.log("domain",domain);
    const expire = new Date();
    expire.setDate(expire.getDate() + 20);
    const options = {
        path: "/",
        expires: expire,
        maxAge: 86400*20,
        domain: domain,
        secure: false,
        httpOnly: false,
        sameSite: true,
    }
    return options;
};
export const OnlineCostPer = 18;
export const OnlineBookCostPer = 10;
export const ItemNameLengthMin = 4;
export const ItemNameLengthMax = 100;
export const ItemGuideNameLengthMax = 100;
export const ItemGuideLengthMax = 2000;
export const ItemPriceMin = 100;
export const ItemPriceMax = 30000;
export const ItemPriceMaxHigh = 200000;
export const ItemTagsMax = 7;
export const EventTagsMax = 3;
export const EventTagNameLengthMin = 4;
export const EventTagNameLengthMax = 50;
export const OwnerNameLengthMin = 1;
export const OwnerNameLengthMax = 50;
export const CompanyNameLengthMin = 1;
export const CompanyNameLengthMax = 50;
export const OwnerProfileLengthMax = 3000;
export const SnsAccountLengthMin = 3;
export const SnsAccountLengthMax = 50;
export const FediverseAccountLengthMax = 100;
export const ConsignSheetTrackingLength = 12;
export const ConsignSheetCourierLength = 10;
export const ConsignSheetMemoLength = 200;

export const SecretAnswerLengthMin = 5;
export const SecretAnswerLengthMax = 20;
export const SecretQuestionLengthMin = 2;
export const SecretQuestionLengthMax = 100;

export const WordsLengthMax = 200;
export const PageNameLengthMin = 4;
export const PageNameLengthMax = 50;
export const PageGuideLengthMax = 2000;

export interface Dataset {
    id: string,
    label: string,    
}
export interface DataErrorset {
    id: string,
    label: string,
	error: boolean,
}
export interface DataErrorset2 {
    id: string,
    label: string,
	id_error: boolean,
	label_error: boolean,
}
export interface EventTag {
	id: string,
    short: string,
    name: string,
	new: boolean,
	selected: boolean,
	start?: string,
	end?: string,
	url?: string,
	admit: boolean,
}
export interface Cardset {
    id: number,
    body: any,
}  
export interface Listset {
    primary: string,
    secondary: string,
	id?:string,
}  
export interface Owner {
    owner_id: number,
	switch_id: number,
	img_id: number,
    owner_name: string,
    customer: Customer,
    isLogined: boolean,
    high_flag: string,
    status: string,
	status_label?:string,
}
export interface OwnerParam {
	suspended: string,
	extended: string,
	prev_extended: string,
	aborted: string,
	confirmed: string,
	deadline: string,
	is_suspended: boolean,
}
export interface OwnerProfile {
    owner_name: string,
    company_name: string,
    kana: string,
    profile: string,
	header_img_id: number,
    img_id: number,
    photo_ids: number[],
    links:Dataset[],
	num_links: number,
    snss:Dataset[],
	start_date: string,
	last_consign: string,
	last_sale: string,
	extended: string,
	status_label?:string,
}
export interface OwnerBank {
    bank_code: string,
    bank_type_id: number,
    bank_cat_id: number,
    bank_name: string,
    bank_store: string,
    bank_signature: string,
    bank_type?: string,
    bank_cat?: string,
    cost?: number,
}
export interface Customer {
    customer_id: number,
    name: string,
    kana: string,
    mail: string,
    unique_id: string,
    addr?: string,
    zip?: string,
    tel?: string,
    zandaka?: number,
	auth_type?: string,
	regist_date?: string,
}
export interface Item {
    item_id:number,
    item_name: string,
    status: string,
    num_stock: number,
    item_guide: string,
    unit: string,
    price: number,
    upto: number,
    page_id: number,
    soldout_id: number,
    cancel_id: number,
	rating_id: number,
    ss_id: number,
    img_id: number,
    sample_flag: string,
	tags: string,
	words: string,
    page_name?:string,
    soldout?:string,
    cancel?:string,
	rating?:string,
    ss?:string,
	charity?:string,
    status_label?:string,
    new_date?:string,
    tax_inc?: string,
    preview_key?: string,
    ss_label?:string,
	admit_flag?: string,
	cats?: string[],
	upack_flag?: string,
	charity_flag?: string,
	cat_id: number,
}
export interface ItemError {
    item_id:boolean,
    item_name: boolean,
    status: boolean,
    num_stock: boolean,
    item_guide: boolean,
    unit: boolean,
    price: boolean,
    upto: boolean,
    page_id: boolean,
    soldout_id: boolean,
    cancel_id: boolean,
	rating_id: boolean,
    ss_id: boolean,
    img_id: boolean,
    sample_flag: boolean,
    page_name?:boolean,
    soldout?:boolean,
    cancel?:boolean,
	rating?:boolean,
    ss?:boolean,
    status_label?:boolean,
    new_date?:boolean,
    tax_inc?: boolean,
    preview_key?: boolean,
    ss_label?:boolean,
	words:boolean,
}
export interface Page {
    page_id:number,
    page_name: string,
    page_guide: string,
    img_id: number,
    status: string,
    status_label?:string,
    num_item: number,
}
export interface Book {
    book_id:number,
    item_id:number,
    book_name: string,
    book_name_sub: string,
    book_version: string,
    status: string,
    num_limit: number,
    notice: string,
    price: number,
    price_notax: number,
    img_id: number,
    admit_id: string,
    status_label?:string,
    admit?:string,
    tax_inc?: string,
    preview_key?: string,
    perform_time_id: string,
    perform_member_id: string,
    perform_admit_id: string,
    persons:string,
    history:string,
    num_page: number,
}
export interface News {
    news_id:number,
    news_name: string,
    news_body: string,
    news_date: string,
    end_date: string,
    photo_ids: number[],
    status: string,
    status_label?:string,
}
export interface Exam {
    name: string,
    kana: string,
    mail: string,
    group: string,
    cat: string,
    text1: string,
    text2: string,
    text3: string,
    url: string,
}
export interface TakebackState {
    how_id: string,
    values: number[],
    samples: string[],
    message: string,
	hasSample: boolean,
	hasError: boolean,
}
export interface Inquiry {
    name: string,
    kana: string,
    mail: string,
    text: string,
}
export interface Visit {
    consign: boolean,
    takeback: boolean,
    date: string,
	hour: string,
    text: string,
}
export interface KbinColabo {
	jiki: string,
	title: string,
	artists: string,
    memo: string,
	banner: string,
	target: string,
}
export interface Info {
    info_id:number,
    title: string,
    body?: string,
    publish_time: string,
    new_flag: boolean,
}
export interface Plan {
    plan_id:number,
    plan_date:string,
    plan_hour:number,
    img_id:number,
    item_id:number,
    item_name:string,
    unit:string,
    su:number,
    prior_key:string,
    prior_flag:string,
    lottery_period:number,
    lottery_period_label:string,
    lottery_flag:boolean,
    item_status:string,
    status:string,
}
export interface NextPlan {
    plan_date:string,
    plan_hour:number,
}
export interface Secret {
    secret_id:number,
    img_id:number,
    item_id:number,
    item_name:string,
    unit:string,
    su:number,
	question:string,
	answer:string,
	created:string,
    item_status:string,
    status:string,
}
export interface Payment {
    sales: number,
    fee: number,
    fee_etc: number,
    amount: number,
    cost: number,
    transfer: number,
    last?: Bill,
}
export interface Bill {
    bill_id: number,
    sales: number,
    fee: number,
    fee_etc: number,
    amount: number,
    cost: number,
    pay_date: string,
    apply_date: string,
    status: string,
    bank_name?: string,
	bank_store?: string,
	bank_code?: string,
	bank_signature?: string,
    cancel_limit?: string,
    status_label?: string,
	reason?: string,
}
export interface BookOption {
    cover_img_flag: string,
    cover_img_top: number,
    cover_img_left: number,
    cover_img_width: number | null,
	cover_img_height: number | null,
	cover_img_type: string,
    cover_title_flag: string,
    cover_title_top: number,
    cover_title_align_id: string,
    cover_writer_flag: string,
    cover_writer_top: number,
    cover_writer_align_id: string,
    serifu_id: number[],
    serifu_chara_id: number,
    serifu_opt1: number,
    serifu_opt2: number,
    midashi1_id: number,
    midashi2_id: number,
    midashi1_chara_id: number,
    midashi2_chara_id: number,
    midashi1_opt1: number,
    midashi2_opt1: number,
    conv_type_id: number[],
    font_opt1: number,
    font_opt2: number,
}
export interface ConsignSheet {
    consign_sheet_id:number,
    memo: string,
    courier: string,
	tracking: string,
	other: string,
	regist_time: string,
}
export interface ReturnBase {
    return_base_id:number,
    how_id: string,
	how_label: string,
	carriage: number,
	upack_code: string,
	delivery_date: string,
	hope_date: string,
	jikantai_id: string,
	jikantai_label: string,
	zip: string,
	ken: string,
	addr: string,
	tel: string,
	status: string,
	status_label: string,
	created: string,
	confirmed: string,
	memo: string,
}
export interface SortOption {
    order: string,
    sort: string,
    per_page: string,
}
export interface SaleSearchCondition {
    item_name: string,
    item_id: string,
    date_year: string,
    date_month: string,  
    date_target: string,
    order_status_ids: string[],
    order_status_bls: boolean[],
    order_type_ids: string[],
    order_type_bls: boolean[],
    option: SortOption,
}
export interface LotterySearchCondition {
    item_name: string,
    item_id: string,
    date_year: string,
    date_month: string,  
    date_target: string,
    order_status_ids: string[],
    order_status_bls: boolean[],
    lottery_result_id: string,
    plan_id: string,
    option: SortOption,
}
export interface StockSearchCondition {
    item_name: string,
    item_id: string,
    date_year: string,
    date_month: string,  
    date_target: string,
    stock_type_ids: string[],
    stock_type_bls: boolean[],
    option: SortOption,
}
export interface ConsignSheetSearchCondition {
    date_year: string,
    date_month: string,  
    date_target: string,
	status: string,
    option: SortOption,
}
export interface ConsignSearchCondition {
    item_name: string,
    item_id: string,
    date_year: string,
    date_month: string,  
    date_target: string,
    stock_type_ids: string[],
    stock_type_bls: boolean[],
    option: SortOption,
}
export interface ReturnBaseSearchCondition {
	date_year: string,
	date_month: string,
	date_target: string,
	status: string,
	option: SortOption,
}
export interface ItemSearchCondition {
    item_name: string,
    page_id: string,
    ss_id: string,
	charity_flag: string,
    sample_ids: string[],
    sample_bls: boolean[],
    stock_ids: string[],
    stock_bls: boolean[],
    date_year: string,
    date_month: string,  
    date_target: string,
    status: string,
	upack: string,
    option: SortOption,
}
export interface PageSearchCondition {
    page_name: string,
    date_year: string,
    date_month: string,  
    date_target: string,
    status: string,
    option: SortOption,
}
export interface BookSearchCondition {
    book_name: string,
    admit_ids: string[],
    admit_bls: boolean[],
    date_year: string,
    date_month: string,  
    date_target: string,
    status: string,
    option: SortOption,
}
export interface NewsSearchCondition {
    news_name: string,
    news_body: string,
    status_ids: string[],
    status_bls: boolean[],
    date_year: string,
    date_month: string,  
    date_target: string,
    option: SortOption,
}
export interface ZaikoSearchCondition {
    item_name: string,
    item_id: string,
    status: string,
    sample_ids: string[],
    sample_bls: boolean[],
    stock_ids: string[],
    stock_bls: boolean[],
    option: SortOption,
}
export interface PlanSearchCondition {
    item_name: string,
    item_id: string,
    date_year: string,
    date_month: string,  
    date_target: string,
    option: SortOption,
}
export interface SecretSearchCondition {
    item_name: string,
    item_id: string,
    date_year: string,
    date_month: string,  
    date_target: string,
    option: SortOption,
}
export interface FavSearchCondition {
    item_id: string,
    item_name: string,
    type_id: string,
    date_year: string,
    date_month: string,  
    date_target: string,
}
export interface RequestSearchCondition {
    item_id: string,
    item_name: string,
    date_year: string,
    date_month: string,  
    date_target: string,
}
export interface BookOutline {
    type: string,
    name: string,
    text: string,
    yoko: string,
}

export interface OwnerMails {
	daily:boolean,
	ordered:boolean,
	soldout:boolean,
	remaining:boolean,
	canceled:boolean,
	lottery_start:boolean,
	lottery_end:boolean,
	daily_hour:number,
	min_remaining:number,
}

export class Inc {
    static dt = new Date();
    static today = Inc.dt.getFullYear() + "/" + (Inc.dt.getMonth()+1) + "/" + Inc.dt.getDate();
    static year = String(Inc.dt.getFullYear());
    static month = String(Inc.dt.getMonth()+1);
    static readonly sorts:Dataset[] = [
        {
            id: "DESC",
            label: "降順",
        },
        {
            id: "ASC",
            label: "昇順",
        },
    ];
    static readonly perPages:Dataset[] = [
        {
            id: "10",
            label: "10件",
        },
        {
            id: "20",
            label: "20件",
        },
        {
            id: "50",
            label: "50件",
        },
    ];
    static readonly exists:Dataset[] = [
        {
            id: "1",
            label: "あり",
        },
        {
            id: "0",
            label: "なし",
        },
    ];

	static readonly literatureTags:Dataset[] = [
		{
			id: "1",
			label: "私小説",
		},
		{
			id: "2",
			label: "SF",
		},
		{
			id: "3",
			label: "ファンタジー",
		},
		{
			id: "4",
			label: "ミステリー",
		},
		{
			id: "5",
			label: "ハードボイルド",
		},
		{
			id: "6",
			label: "時代歴史",
		},
		{
			id: "7",
			label: "ヒューマンドラマ",
		},
		{
			id: "8",
			label: "恋愛",
		},
		{
			id: "9",
			label: "青春",
		},
		{
			id: "10",
			label: "BL",
		},
		{
			id: "11",
			label: "百合",
		},
		{
			id: "12",
			label: "ホラー",
		},
		{
			id: "13",
			label: "ノンフィクション",
		},
		{
			id: "14",
			label: "コメディ",
		},
		{
			id: "15",
			label: "不条理",
		},
		{
			id: "16",
			label: "官能",
		},
		{
			id: "17",
			label: "ライトノベル",
		},
		{
			id: "18",
			label: "純文学",
		},
		{
			id: "51",
			label: "短編集",
		},
		{
			id: "52",
			label: "アンソロジー",
		},
		{
			id: "53",
			label: "リレーノベル",
		},
		{
			id: "54",
			label: "シリーズもの",
		},
		{
			id: "99",
			label: "わかりません",
		},
		{
			id: "91",
			label: "R15+",
		},
		{
			id: "92",
			label: "R18+",
		},
	];

    static readonly kens:Dataset[] = [
        {
            id:"1",
            label:"北海道",
        },
        {
            id:"2",
            label:"青森県",
        },
        {
            id:"3",
            label:"岩手県",
        },
        {
            id:"4",
            label:"宮城県",
        },
        {
            id:"5",
            label:"秋田県",
        },
        {
            id:"6",
            label:"山形県",
        },
        {
            id:"7",
            label:"福島県",
        },
        {
            id:"8",
            label:"茨城県",
        },
        {
            id:"9",
            label:"栃木県",
        },
        {
            id:"10",
            label:"群馬県",
        },
        {
            id:"11",
            label:"埼玉県",
        },
        {
            id:"12",
            label:"千葉県",
        },
        {
            id:"13",
            label:"東京都",
        },
        {
            id:"14",
            label:"神奈川県",
        },
        {
            id:"15",
            label:"新潟県",
        },
        {
            id:"16",
            label:"富山県",
        },
        {
            id:"17",
            label:"石川県",
        },
        {
            id:"18",
            label:"福井県",
        },
        {
            id:"19",
            label:"山梨県",
        },
        {
            id:"20",
            label:"長野県",
        },
        {
            id:"21",
            label:"岐阜県",
        },
        {
            id:"22",
            label:"静岡県",
        },
        {
            id:"23",
            label:"愛知県",
        },
        {
            id:"24",
            label:"三重県",
        },
        {
            id:"25",
            label:"滋賀県",
        },
        {
            id:"26",
            label:"京都府",
        },
        {
            id:"27",
            label:"大阪府",
        },
        {
            id:"28",
            label:"兵庫県",
        },
        {
            id:"29",
            label:"奈良県",
        },
        {
            id:"30",
            label:"和歌山県",
        },
        {
            id:"31",
            label:"鳥取県",
        },
        {
            id:"32",
            label:"島根県",
        },
        {
            id:"33",
            label:"岡山県",
        },
        {
            id:"34",
            label:"広島県",
        },
        {
            id:"35",
            label:"山口県",
        },
        {
            id:"36",
            label:"徳島県",
        },
        {
            id:"37",
            label:"香川県",
        },
        {
            id:"38",
            label:"愛媛県",
        },
        {
            id:"39",
            label:"高知県",
        },
        {
            id:"40",
            label:"福岡県",
        },
        {
            id:"41",
            label:"佐賀県",
        },
        {
            id:"42",
            label:"長崎県",
        },
        {
            id:"43",
            label:"熊本県",
        },
        {
            id:"44",
            label:"大分県",
        },
        {
            id:"45",
            label:"宮崎県",
        },
        {
            id:"46",
            label:"鹿児島県",
        },
        {
            id:"47",
            label:"沖縄県",
        }        
    ];
    static readonly pageStatus = [
        {
            id:"1",
            label:"利用可",
        },
        {
            id:"0",
            label:"保留",
        },
    ];
    static readonly itemUpack = [
        {
            id:"2",
            label:"ゆうパケットOK",
        },
        {
            id:"1",
            label:"ゆうパケット不可",
        },
    ];
    static readonly itemStatus = [
        {
            id:"1",
            label:"販売中",
        },
        {
            id:"2",
            label:"抽選受付中",
        },
        {
            id:"3",
            label:"予約受付中",
        },
        {
            id:"11",
            label:"近日発売",
        },
        {
            id:"12",
            label:"近日抽選",
        },
        {
            id:"13",
            label:"近日予約",
        },
        {
            id:"10",
            label:"在庫なし",
        },
        {
            id:"99",
            label:"非公開",
        },
    ];
    static readonly consignStatus = [
        {
            id:"0",
            label:"未提出",
        },
        {
            id:"1",
            label:"完了",
        },
        {
            id:"9",
            label:"対応中",
        },
    ];
    static readonly returnStatus = [
        {
            id:"0",
            label:"未処理",
        },
        {
            id:"1",
            label:"完了",
        },
        {
            id:"9",
            label:"対応中",
        },
    ];
    static readonly orderStatus = [
        {
            id:"1",
            label:"対応中",
        },
        {
            id:"2",
            label:"完了",
        },
        {
            id:"9",
            label:"キャンセル",
        },
    ];
    static readonly lotteryOrderStatus = [
        {
            id:"1",
            label:"対応中",
        },
        {
            id:"2",
            label:"完了",
        },
        {
            id:"9",
            label:"キャンセル",
        },
    ];
    static readonly orderTypes = [
        {
            id:"1",
            label:"オンラインストア",
        },
        {
            id:"2",
            label:"井の頭倉庫",
        },
    ];
    static readonly lotteryResults = [
        {
            id:"1",
            label:"アタリ",
        },
        {
            id:"2",
            label:"ハズレ",
        },
        {
            id:"0",
            label:"抽選待ち",
        }
    ];
    static readonly saleTypes = [
        {
            id:"1",
            label:"納品",
        },
        {
            id:"2",
            label:"返品",
        },
        {
            id:"3",
            label:"破棄",
        },
        {
            id:"9",
            label:"その他",
        },
    ];
    static readonly stockTypes = [
        {
            id:"1",
            label:"納品",
        },
        {
            id:"2",
            label:"返品",
        },
        {
            id:"3",
            label:"破棄",
        },
        {
            id:"9",
            label:"その他",
        },
    ];
    static readonly soldouts = [
        {
            id:"2",
            label:"もう作らないつもりです",
        },
        {
            id:"1",
            label:"また作るつもりです",
        },
        {
            id:"3",
            label:"まだわかりません",
        },
    ];
    static readonly cancels = [
        {
            id:"1",
            label:"すぐに販売再開します",
        },
        {
            id:"2",
            label:"あとで発売日を設定します",
        },
    ];

    static readonly sss = [
        {
            id:"0",
            label:"通常販売（抽選販売）",
        },
        {
            id:"1",
            label:"予約販売",
        },
    ];
    static readonly units = [
        {
            id:'個',
            label:'個',
        },
        {
            id:'冊',
            label:'冊',
        },
        {
            id:'枚',
            label:'枚',
        },
        {
            id:'本',
            label:'本',
        },
        {
            id:'組',
            label:'組',
        },
        {
            id:'セット',
            label:'セット',
        },
        {
            id:'ペア',
            label:'ペア',
        },
        {
            id:'匹',
            label:'匹',
        },
        {
            id:'巻',
            label:'巻',
        },
        {
            id:'杯',
            label:'杯',
        },
        {
            id:'点',
            label:'点',
        },
        {
            id:'羽',
            label:'羽',
        },
        {
            id:'袋',
            label:'袋',
        },
        {
            id:'足',
            label:'足',
        },
        {
            id:'部',
            label:'部',
        },
        {
            id:'頭',
            label:'頭',
        },        
        {
            id:'切',
            label:'切',
        },        
    ];
    static readonly taxs = [
        {
            id:"1",
            label:"税込",
        },
        {
            id:"0",
            label:"税抜",
        },
    ];
    static readonly bankTypes = [
        {
            id:"1",
            label:"ゆうちょ",
        },
        {
            id:"2",
            label:"銀行・信用金庫",
        },
    ];
    static readonly bankCats = [
        {
            id:"1",
            label:"普通",
        },
        {
            id:"2",
            label:"当座",
        },
        {
            id:"3",
            label:"貯蓄",
        },
    ];
    static readonly newsStatus = [
        {
            id:"1",
            label:"公開可",
        },
        {
            id:"0",
            label:"下書き",
        },
    ];
    static readonly bookStatus = [
        {
            id:"1",
            label:"公開",
        },
        {
            id:"0",
            label:"非公開",
        },
    ];
    static readonly takebackHows = [
        {
            id:"1",
            label:"ゆうパック",
        },
        {
            id:"3",
            label:"なるべく安く",
        },
        {
            id:"2",
            label:"井の頭倉庫",
        },
        {
            id:"9",
            label:"その他",
        },
    ];
    static readonly withSamples = [
        {
            id:"1",
            label:"引き取る",
        },
        {
            id:"2",
            label:"引き取らない",
        },
    ];
    static readonly planHours = [
        {
            id:"9",
            label:"9時",
        },
        {
            id:"12",
            label:"12時",
        },
        {
            id:"19",
            label:"19時",
        }
    ];
    static readonly lotteryPeriods = [
        {
            id:"1",
            label:"1時間",
        },
        {
            id:"6",
            label:"6時間",
        },
        {
            id:"12",
            label:"12時間",
        },
        {
            id:"24",
            label:"1日",
        },
        {
            id:"48",
            label:"2日",
        },
        {
            id:"72",
            label:"3日",
        }
    ];
    static readonly uses = [
        {
            id:"1",
            label:"使う",
        },
        {
            id:"0",
            label:"使わない",
        },
    ];
    static readonly favTypes = [
        {
            id:"1",
            label:"スキ",
        },
        {
            id:"6",
            label:"プレゼント用",
        },
        {
            id:"3",
            label:"気になる",
        },
        {
            id:"4",
            label:"創作の参考",
        },
        {
            id:"5",
            label:"宝物",
        },
        {
            id:"9",
            label:"その他",
        },
    ];
    static readonly qaCategorys = [
        {
            id:"9",
            label:"よくある質問",
        },
        {
            id:"1",
            label:"作家登録と手数料",
        },
        {
            id:"3",
            label:"商品登録",
        },
        {
            id:"4",
            label:"納品",
        },
        {
            id:"2",
            label:"販売と発送",
        },
        {
            id:"5",
            label:"抽選販売",
        },
        {
            id:"6",
            label:"先行販売",
        },
        {
            id:"99",
            label:"その他",
        },
    ]
    static readonly bookAdmits:Dataset[] = [
        {
            id: "0",
            label: "未申請",
        },
        {
            id: "1",
            label: "許可済",
        },
        {
            id: "2",
            label: "申請中",
        },
    ];
    static readonly performMembers:Dataset[] = [
        {
            id:"1",
            label:"1人",
        },
        {
            id:"2",
            label:"2人",
        },
        {
            id:"3",
            label:"3人",
        },
        {
            id:"4",
            label:"4～6人",
        },
        {
            id:"5",
            label:"6～9人",
        },
        {
            id:"6",
            label:"10人以上",
        },
    ]
    static readonly performAdmits:Dataset[] = [
        {
            id:"1",
            label:"不可",
        },
        {
            id:"2",
            label:"応相談",
        },
        {
            id:"3",
            label:"フリー",
        },
    ]
    static readonly performTimes:Dataset[] = [
        {
            id: "1",
            label: "10分以内",
        },
        {
            id: "2",
            label: "10～30分",
        },
        {
            id: "3",
            label: "30～60分",
        },
        {
            id: "4",
            label: "60～90分",
        },
        {
            id: "5",
            label: "90分以上",
        }
    ]
    static readonly aligns:Dataset[] = [
        {
            id: "L",
            label: "左",
        },
        {
            id: "C",
            label: "中央",
        },
        {
            id: "R",
            label: "右",
        },
    ]
    static readonly bookMidashiCharas:Dataset[] = [
        {
            id: "1",
            label: "半角の#",
        },
        {
            id: "2",
            label: "全角の＃",
        },
        {
            id: "3",
            label: "全角の●又は○",
        },
        {
            id: "4",
            label: "全角の■又は□",
        },
        {
            id: "6",
            label: "全角の＜",
        },
        {
            id: "7",
            label: "全角の［",
        },
        {
            id: "8",
            label: "全角の【",
        },
    ]
    static readonly bookSerifuCharas:Dataset[] = [
        {
            id:"1",
            label:"全角の空白が２つ以上ある",
        },
        {
            id:"2",
            label:"タブがある",
        },
        {
            id:"3",
            label:"全角の：がある",
        },
        {
            id:"4",
            label:"半角の:がある",
        },
    ]
    static readonly ratings:Dataset[] = [
        {
            id:"0",
            label:"全年齢対象",
        },
        {
            id:"15",
            label:"R15+",
        },
        {
            id:"18",
            label:"R18+",
        },
    ]
    static readonly couriers:Dataset[] = [
        {
            id:"郵便局",
            label:"郵便局",
        },
        {
            id:"ヤマト",
            label:"クロネコヤマト",
        },
        {
            id:"佐川",
            label:"佐川急便",
        },
        {
            id:"西濃",
            label:"西濃運輸",
        },
        {
            id:"福山",
            label:"福山通運",
        },
        {
            id:"その他",
            label:"その他",
        },
    ]
	static readonly kbincolabotargets:Dataset[] = [
		{
			id: "1",
			label: "参加作家さんの登録作品全部が対象",
		},
		{
			id: "2",
			label: "参加作家さんの登録作品の一部が対象（対象作品を個別に指定する）",
		},
		{
			id: "9",
			label: "まだ決めてない",
		},
	]
	static readonly kbincolabobanners:Dataset[] = [
		{
			id: "1",
			label: "架空ストアに任せたい",
		},
		{
			id: "2",
			label: "自分で作りたい",
		},
		{
			id: "9",
			label: "まだ決めてない",
		},
	]
	static readonly charitys:Dataset[] = [
		{
			id: "0",
			label: "いいえ",
		},
		{
			id: "1",
			label: "はい（売上は寄付予定）",
		},
	]

    static readonly snsNames = ["twitter","facebook","instagram","googleplus","tumblr","fediverse","threads","mastodon","misskey"];

    static readonly defaultOwner = ()=>{
        let owner:Owner = {
            owner_id: 0,
			switch_id: 0,
			img_id: 0,
            owner_name: "",
            customer: Inc.defaultCustomer(),
            isLogined: false,
            high_flag: "0",
            status: "0",
        }
        return owner;
    };
    static readonly defaultOwnerProfile = ()=>{
        let profile:OwnerProfile = {
            owner_name: "",
            company_name: "",
            kana: "",
            profile: "",
			header_img_id: 0,
            img_id: 0,
            photo_ids: [],
            links: [],
            snss: [],
			num_links: 0,
			start_date: 'なし',
			last_consign: 'なし',
			last_sale: 'なし',
			extended: 'なし',
			status_label:'未登録',
        }
        return profile;
    };
    static readonly defaultOwnerBank = ()=>{
        let bank:OwnerBank = {
            bank_code: "",
            bank_type_id: 0,
            bank_cat_id: 0,
            bank_name: "",
            bank_store: "",
            bank_signature: "",
            bank_type: "",
            cost: 0,
        }
        return bank;
    };
    static readonly defaultOwnerParam = ()=>{
        let param:OwnerParam = {
			suspended: "",
			extended: "",
			prev_extended: "",
			aborted: "",
			confirmed: "",
			deadline: "",
			is_suspended: false,
        }
        return param;
    };
    static readonly defaultCustomer = ()=>{
        let customer:Customer = {
            customer_id: 0,
            name: "",
            kana: "",
            mail: "",
            unique_id: "",
			addr: "",
			auth_type: "",
        }
        return customer;
    };
    static readonly defaultItem = ()=>{
        let item:Item = {
            item_id: 0,
            item_name: "",
            status: "0",
            num_stock: 0,
            item_guide: "",
            unit: "",
            price: 100,
            upto: 0,
            page_id: 0,
            soldout_id: 2,
            cancel_id: 1,
			rating_id: 0,
            ss_id: 0,
            img_id: 0,
			tags: "",
			words: "",
            sample_flag: '0',
			admit_flag: '0',
			upack_flag: '0',
            ss_label:"",
			cat_id: 0,
        }
        return item;
    };
    static readonly defaultItemError = ()=>{
        let item:ItemError = {
            item_id: false,
            item_name: false,
            status: false,
            num_stock: false,
            item_guide: false,
            unit: false,
            price: false,
            upto: false,
            page_id: false,
            soldout_id: false,
            cancel_id: false,
			rating_id: false,
            ss_id: false,
            img_id: false,
            sample_flag: false,
            ss_label:false,
			words:false,
        }
        return item;
    };
    static readonly defaultPage = ()=>{
        let page:Page = {
            page_id: 0,
            page_name: "",
            page_guide: "",
            img_id: 0,
            status: "0",
            num_item: 0,
        }
        return page;
    };
    static readonly defaultBook = ()=>{
        let book:Book = {
            book_id: 0,
            item_id: 0,
            book_name: "",
            book_name_sub: "",
            book_version: "",
            status: "0",
            status_label: "",
            num_limit: 0,
            num_page: 0,
            notice: "",
            price: 100,
            price_notax: 0,
            img_id: 0,
            admit_id: "0",
            tax_inc: "1",
            perform_time_id: "1",
            perform_member_id: "1",
            perform_admit_id: "1",
            history: "",
            persons: "",
        }
        return book;
    };
    static readonly defaultBookOption = ()=>{
        let bookoption:BookOption = {
            cover_img_flag: "0",
            cover_img_top: 12,
            cover_img_left: 15,
            cover_img_width: null,
			cover_img_height: null,
			cover_img_type: "",
            cover_title_flag: "1",
            cover_title_top: 80,
            cover_title_align_id: "C",
            cover_writer_flag: "1",
            cover_writer_top: 200,
            cover_writer_align_id: "C",
            serifu_id:[],
            serifu_chara_id: 0,
            serifu_opt1:0,
            serifu_opt2:0,
            midashi1_id:0,
            midashi2_id:0,
            midashi1_chara_id:0,
            midashi2_chara_id:0,
            midashi1_opt1:0,
            midashi2_opt1:0,
            conv_type_id:[],
            font_opt1: 0,
            font_opt2: 0,
        }
        return bookoption;
    }
    static readonly defaultNews = ()=>{
        let news:News = {
            news_id: 0,
            news_name: "",
            news_body: "",
            news_date: "",
            end_date: "",
            photo_ids: [],
            status: "0",
            status_label: "新規",
        }
        return news;
    };
    static readonly defaultInfo = ()=>{
        let info:Info = {
            info_id: 0,
            title: "",
            body: "",
            publish_time: "",
            new_flag: false,
        }
        return info;
    };
    static readonly defaultPlan = ()=>{
        let plan:Plan = {
            plan_id:0,
            plan_date:"",
            plan_hour:9,
            img_id:0,
            item_id:0,
            item_name:"",
            unit:"",
            su:0,
            prior_key:"",
            prior_flag:"0",
            lottery_period:1,
            lottery_period_label:"",
            lottery_flag:false,
            item_status:"0",
            status:"0",        
        }
        return plan;
    }
    static readonly defaultSecret = ()=>{
        let secret:Secret = {
            secret_id:0,
            img_id:0,
            item_id:0,
            item_name:"",
            unit:"",
            su:0,
			question:"",
			answer:"",
			created:"",
            item_status:"0",
            status:"0",        
        }
        return secret;
    }
    static readonly defaultPayment = ()=>{
        let payment:Payment = {
            sales: 0,
            fee: 0,
            fee_etc: 0,
            amount: 0,
            cost: 0,
            transfer: 0,
        }
        return payment;
    };
    static readonly defaultConsignSheet = ()=>{
        let consign:ConsignSheet = {
			consign_sheet_id: 0,
			memo: '',
			tracking: '',
			courier: '',
			other: '',
			regist_time: '',
        }
        return consign;
    };
	static readonly defaultReturnBase = ()=>{
		let base:ReturnBase = {
			return_base_id:0,
			how_id: '',
			how_label: '',
			carriage: 0,
			upack_code: '',
			delivery_date: '',
			hope_date: '',
			jikantai_id: '',
			jikantai_label: '',
			zip: '',
			ken: '',
			addr: '',
			tel: '',
			status: '0',
			status_label: '',
			memo: '',
			created: '',
			confirmed: '',
		}
		return base;
	}
    static readonly defaultBill = ()=>{
        let bill:Bill = {
            bill_id: 0,
            sales: 0,
            fee: 0,
            fee_etc: 0,
            amount: 0,
            cost: 0,
            pay_date: "",
            apply_date: "",
            status: "0",
        }
        return bill;
    };
    static readonly defaultSortOption = (order?:string)=>{
        let opt:SortOption = {
            order: "",
            sort: "DESC",
            per_page: "10",
        }
        if( order ){
            opt.order = order;
        }
        return opt;
    };
    static readonly defaultSaleSearchCondition = ()=>{
        let cond:SaleSearchCondition = {
            "item_name": "",
            "item_id": "",
            "date_year": "",
            "date_month": "",
            "date_target": "original_order_time",
            "order_status_ids": [],
            "order_status_bls": new Array<boolean>(Inc.orderStatus.length).fill(false),
            "order_type_ids": [],
            "order_type_bls": new Array<boolean>(Inc.orderTypes.length).fill(false),
            "option": {
                "order": "original_order_time",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultLotterySearchCondition = ()=>{
        let cond:LotterySearchCondition = {
            "item_name": "",
            "item_id": "",
            "date_year": "",
            "date_month": "",
            "date_target": "order_time",
            "order_status_ids": [],
            "order_status_bls": new Array<boolean>(Inc.lotteryOrderStatus.length).fill(false),
            "lottery_result_id": "",
            "plan_id": "",
            "option": {
                "order": "order_time",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultStockSearchCondition = ()=>{
        let cond:StockSearchCondition = {
            "item_name": "",
            "item_id": "",
            "date_year": "",
            "date_month": "",
            "date_target": "stock_date",
            "stock_type_ids": [],
            "stock_type_bls": new Array<boolean>(Inc.stockTypes.length).fill(false),
            "option": {
                "order": "stock_id",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultConsignSheetSearchCondition = ()=>{
        let cond:ConsignSheetSearchCondition = {
            "date_year": "",
            "date_month": "",
            "date_target": "regist_time",
			"status":"",
            "option": {
                "order": "consign_sheet_id",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultReturnBaseSearchCondition = ()=>{
        let cond:ReturnBaseSearchCondition = {
            "date_year": "",
            "date_month": "",
            "date_target": "regist_time",
			"status":"",
            "option": {
                "order": "return_base_id",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultZaikoSearchCondition = ()=>{
        let cond:ZaikoSearchCondition = {
            "item_name": "",
            "item_id": "",
            "status": "",
            "sample_ids": [],
            "sample_bls": new Array<boolean>(Inc.exists.length).fill(false),
            "stock_ids": [],
            "stock_bls": new Array<boolean>(Inc.exists.length).fill(false),
            "option": {
                "order": "item_id",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultItemSearchCondition = ()=>{
        let cond:ItemSearchCondition = {
            "item_name": "",
            "page_id": "",
            "ss_id": "",
            "status": "",
			"charity_flag": "",
            "sample_ids": [],
            "sample_bls": new Array<boolean>(Inc.exists.length).fill(false),
            "stock_ids": [],
            "stock_bls": new Array<boolean>(Inc.exists.length).fill(false),
            "date_target": "",
            "date_year": "",
            "date_month": "",
			"upack": "",
            "option": {
                "order": "item_id",
                "sort": "DESC",
                "per_page": "20",
            },
        }
        return cond;
    }
    static readonly defaultPageSearchCondition = ()=>{
        let cond:PageSearchCondition = {
            "page_name": "",
            "date_target": "",
            "date_year": "",
            "date_month": "",
            "status": "",
            "option": {
                "order": "page_id",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultBookSearchCondition = ()=>{
        let cond:BookSearchCondition = {
            "book_name": "",
            "admit_ids": [],
            "admit_bls": new Array<boolean>(Inc.bookAdmits.length).fill(false),
            "status": "",
            "date_target": "",
            "date_year": "",
            "date_month": "",
            "option": {
                "order": "item_id",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultNewsSearchCondition = ()=>{
        let cond:NewsSearchCondition = {
            "news_name": "",
            "news_body": "",
            "status_bls": new Array<boolean>(Inc.newsStatus.length).fill(false),
            "status_ids": [],
            "date_target": "",
            "date_year": "",
            "date_month": "",
            "option": {
                "order": "news_date",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultPlanSearchCondition = ()=>{
        let cond:PlanSearchCondition = {
            "item_name": "",
            "item_id": "",
            "date_year": "",
            "date_month": "",
            "date_target": "plan_date",
            "option": {
                "order": "plan_date",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultSecretSearchCondition = ()=>{
        let cond:SecretSearchCondition = {
            "item_name": "",
            "item_id": "",
            "date_year": "",
            "date_month": "",
            "date_target": "regist_time",
            "option": {
                "order": "secret_id",
                "sort": "DESC",
                "per_page": "20",
            }
        }
        return cond;
    }
    static readonly defaultFavSearchCondition = ()=>{
        let cond:FavSearchCondition = {
            "item_name": "",
            "item_id": "",
            "type_id": "",
            "date_year": "",
            "date_month": "",
            "date_target": "regist_time",
        }
        return cond;
    }
    static readonly defaultRequestSearchCondition = ()=>{
        let cond:RequestSearchCondition = {
            "item_name": "",
            "item_id": "",
            "date_year": "",
            "date_month": "",
            "date_target": "regist_time",
        }
        return cond;
    }

    static readonly convItem = (data:any)=>{
        let item:Item = Inc.defaultItem();
        item.item_id = data.item_id;
        item.item_name = data.item_name;
        item.status = data.status;
        item.num_stock = parseInt(data.num_stock);
		if( data.item_guide ){
        	item.item_guide = data.item_guide;
		} else {
			item.item_guide = '';
		}
        item.unit = data.unit;
        item.price = data.price;
        item.upto = data.upto;
        item.page_id = data.page_id;
        item.soldout_id = data.soldout_id;
        item.cancel_id = data.cancel_id;
		item.rating_id = data.rating_id;
        item.ss_id = data.ss_id;
        item.img_id = data.img_id;
        item.page_name = data.page_name;
        item.soldout = data.soldout;
        item.cancel = data.cancel;
		item.rating = data.rating;
		if( data.words ){
			item.words = data.words;
		} else {
			item.words = '';
		}
        item.ss = data.ss;
        item.status_label = data.status_label;
        item.new_date = data.new_date;
        item.tax_inc = data.tax_inc;
        item.preview_key = data.preview_key;
		if( data.cats ){
			item.cats = data.cats;
		}
		if( data.admit_flag ){
			item.admit_flag = data.admit_flag;
		}
		if( data.upack_flag ){
			item.upack_flag = data.upack_flag;
		}
		if( data.sample_flag ){
			item.sample_flag = data.sample_flag;
		}
		if( data.charity_flag ){
			item.charity_flag = data.charity_flag;
		} else {
			item.charity_flag = '0';
		}
		item.charity = data.charity;
		if( data.cat_id ){
			item.cat_id = data.cat_id;
		}
        return item;
    }
    static readonly convPage = (data:any)=>{
        let page:Page = Inc.defaultPage();
        page.page_id = data.page_id;
        page.page_name = data.page_name;
        page.page_guide = data.page_guide;
        page.img_id = data.img_id;
        page.status = data.status;
        page.status_label = data.status_label;
        page.num_item = data.num_item;
        return page;
    }
    static readonly convBook = (data:any)=>{
        let book:Book = Inc.defaultBook();
        book.item_id = data.item_id;
        book.book_id = data.book_id;
        book.book_name = data.book_name;
        book.book_name_sub = data.book_name_sub;
        book.book_version = data.book_version;
        book.status = data.status;
        book.num_page = parseInt(Inc.IfNull(data.num_page,"0"));
        book.num_limit = parseInt(Inc.IfNull(data.num_limit,"0"));
        book.notice = data.notice;
        book.price = data.price;
        book.price_notax = data.price_notax;
        book.img_id = data.img_id;
        book.status_label = data.status_label;
        book.tax_inc = data.tax_inc;
        book.perform_time_id = Inc.IfNull(data.perform_time_id,"1");
        book.perform_member_id = Inc.IfNull(data.perform_member_id,"1");
        book.perform_admit_id = Inc.IfNull(data.perform_admit_id,"1");
        book.persons = data.persons;
        book.history = data.history;
        book.admit = data.admit;
        book.admit_id = data.admit_id;
        return book;
    }
    static readonly convBookOption = (data:any)=>{
        let option:BookOption = Inc.defaultBookOption();
        option.cover_img_flag = String(data.cover_img_flag);
        option.cover_img_top = parseInt(Inc.IfNull(data.cover_img_top,"12"));
        option.cover_img_left = parseInt(Inc.IfNull(data.cover_img_left,"15"));
        option.cover_img_width = Inc.IfNull(data.cover_img_width,"");
		option.cover_img_height = Inc.IfNull(data.cover_img_height,"");
		option.cover_img_type = Inc.IfNull(data.cover_img_type,"");
        option.cover_title_flag = String(Inc.IfNull(data.cover_title_flag,0));
        option.cover_title_top = parseInt(Inc.IfNull(data.cover_title_top,"160"));
        option.cover_title_align_id = Inc.IfNull(data.cover_title_align_id,"C");
        option.cover_writer_flag = String(Inc.IfNull(data.cover_writer_flag,0));
        option.cover_writer_top = parseInt(Inc.IfNull(data.cover_writer_top,"200"));
        option.cover_writer_align_id = Inc.IfNull(data.cover_writer_align_id,"C");
        option.serifu_id = Inc.IfNull(data.serifu_id,[]);
        option.serifu_chara_id = Inc.IfNull(data.serifu_chara_id,1);
        option.serifu_opt1 = Inc.IfNull(data.serifu_opt1,0);
        option.serifu_opt2 = Inc.IfNull(data.serifu_opt2,0);
        option.midashi1_id = Inc.IfNull(data.midashi1_id,0);
        option.midashi2_id = Inc.IfNull(data.midashi2_id,0);
        option.midashi1_chara_id = Inc.IfNull(data.midashi1_chara_id,1);
        option.midashi2_chara_id = Inc.IfNull(data.midashi2_chara_id,1);
        option.midashi1_opt1 = Inc.IfNull(data.midashi1_opt1,0);
        option.midashi2_opt1 = Inc.IfNull(data.midashi2_opt1,0);
        option.conv_type_id = Inc.IfNull(data.conv_type_id,[]);
        option.font_opt1 = Inc.IfNull(data.font_opt1,0);
        option.font_opt2 = Inc.IfNull(data.font_opt2,0);
        return option;
    }
    static readonly convNews = (data:any)=>{
        let news:News = Inc.defaultNews();
        news.news_id = data.news_id;
        news.news_name = data.news_name;
        news.news_body = data.news_body;
        news.photo_ids = data.photo_ids;
        news.news_date = data.news_date;
        news.end_date = data.end_date;
        news.status = data.status;
        news.status_label = data.status_label;
        return news;
    }
    static readonly convOwnerProfile = (data:any)=>{
        let profile:OwnerProfile = Inc.defaultOwnerProfile();
        profile.owner_name = data.owner_name;
		if( data.company_name ){
        	profile.company_name = data.company_name;
		} else {
			profile.company_name = '';
		}
        profile.kana = data.kana;
        profile.profile = data.profile;
        profile.img_id = parseInt(data.img_id);
		profile.header_img_id = parseInt(data.header_img_id);
        profile.photo_ids = data.photo_ids;
        profile.links = data.links;
        profile.snss = data.snss;
		profile.num_links = data.num_links;
		if( data.start_date ){
			profile.start_date = data.start_date;
		} else {
			profile.start_date = "なし";
		}
		if( data.last_consign ){
			profile.last_consign = data.last_consign;
		} else {
			profile.last_consign = "なし";
		}
		if( data.last_sale ){
			profile.last_sale = data.last_sale;
		} else {
			profile.last_sale = "なし";
		}
		if( data.extended ){
			profile.extended = data.extended;
		} else {
			profile.extended = "なし";
		}
		if( data.status_label ){
			profile.status_label = data.status_label;
		} else {
			profile.status_label = "未登録";
		}
        return profile;
    }
    static readonly convOwnerBank = (data:any)=>{
        let bank:OwnerBank = Inc.defaultOwnerBank();
        bank.bank_code = data.bank_code;
        bank.bank_type_id = parseInt(data.bank_type_id);
        bank.bank_type = data.bank_type;
        bank.bank_cat_id = parseInt(data.bank_cat_id);
        bank.bank_cat = data.bank_cat;
        bank.bank_name = data.bank_name;
        bank.bank_store = data.bank_store;
        bank.bank_signature = data.bank_signature;
        bank.cost = parseInt(data.cost);
        return bank;
    }
    static readonly convOwnerParam = (data:any)=>{
        let param:OwnerParam = Inc.defaultOwnerParam();
        param.suspended = data.suspended;
		param.prev_extended = data.prev_extended;
		param.extended = data.extended;
		param.aborted = data.aborted;
		param.confirmed = data.confirmed;
		param.deadline = data.deadline;
		param.is_suspended = data.is_suspended;
		//console.log("param",param);
        return param;
    }
    static readonly convCustomer = (data:any)=>{
        let customer:Customer = Inc.defaultCustomer();
		customer.mail = data.mail;

		if( data.customer_name1 ){
			customer.name = data.customer_name1+data.customer_name2;
		}
		if( data.customer_name1_kana ){
			customer.kana = data.customer_name1_kana+data.customer_name2_kana;
		}
		if( data.tel ){
			customer.tel = data.tel;
		}
		if( data.zip ){
			customer.zip = data.zip;
		}
		if( data.ken ){
			customer.addr = data.ken;
		}
		if( data.addr1 ){
			customer.addr += data.addr1;
		}
		if( data.addr2 ){
			customer.addr += data.addr2;
		}
		if( data.addr3 ){
			customer.addr += data.addr3;
		}
		if( data.auth_type==='P' ){
			customer.auth_type = 'パスワード';
		}
		if( data.auth_type==='T' ){
			customer.auth_type = 'Twitter';
		}
		if( data.auth_type==='F' ){
			customer.auth_type = 'Facebook';
		}
		if( data.auth_type==='G' ){
			customer.auth_type = 'Google';
		}
		customer.regist_date = data.regist_date;

        return customer;
    }
    static readonly IfNull = ( str:any , empty:any )=>{
        if( str ){
            return str;
        } else {
            return empty;
        }
    }
}